import colors from '../components/_foundations/colors.json';

export default class tagHelper {
  static tagColor = (tag) => {
    const tagColors = {
      topic: colors.magenta500,
      job: colors.aqua700,
      JobCategory: colors.aqua700,
      Location: colors.aqua800,
      Keyword: colors.aqua600,
      default: colors.neutral800,
      excluded: colors.danger200,
    };
    if (!tag) return tagColors.default;

    return tag.excluded
      ? tagColors.excluded
      : tagColors[tag.category] || tagColors[tag.type] || tagColors.default;
  };

  static tagTextColor = (tag) => {
    const tagTextColors = {
      default: colors.neutral10,
      excluded: colors.neutral900,
    };
    if (!tag) return tagTextColors.default;

    return tag.excluded ? tagTextColors.excluded : tagTextColors.default;
  };
}
